const JutgeColors = {
    colors: {
        color1: '#285a4a',
        color2: '#377a37',
        color3: '#527e4c',
        color4: '#6d8261',
        color5: '#9ab383',
        color6: '#e1e0c7',
    },
    // 10 colores máximamente distintos entre sí (bien separados en el espectro)
    // para distinguir aulas de un vistazo. Pensado para hasta 10 aulas sin repetir.
    aulaColors: [
        '#e6194B', // rojo
        '#3cb44b', // verde
        '#4363d8', // azul
        '#f58231', // naranja
        '#911eb4', // morado
        '#42d4f4', // cian
        '#f032e6', // magenta
        '#bf9000', // oro oscuro
        '#469990', // teal
        '#9A6324', // marrón
    ],
};

// Devuelve un color estable y muy distinto por aula. Para <= 10 aulas no se repiten.
export const aulaColor = (idAula?: number | string | null): string => {
    if (idAula === undefined || idAula === null || idAula === '') return '#8c8c8c';
    const n = typeof idAula === 'number' ? idAula : parseInt(String(idAula), 10);
    if (Number.isNaN(n)) return '#8c8c8c';
    const palette = JutgeColors.aulaColors;
    return palette[((n % palette.length) + palette.length) % palette.length];
};

export default JutgeColors;
